import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Kicker, Reveal } from "../components/Reveal";
import { IMAGES } from "../lib/data";

const CARDS = [
  {
    title: "Injectables",
    image: IMAGES.injectables,
    alt: "Natural injectable results",
    items: ["Botox & Dysport", "Dermal fillers", "Wrinkle relaxers / neurotoxins"],
    service: "botox",
  },
  {
    title: "Medical Weight Loss",
    image: IMAGES.consultation,
    alt: "Weight loss consultation",
    items: ["GLP-1 treatment plans & injection training", "Baseline measurements & progress tracking", "Monthly memberships from $99"],
    service: "weight-loss-consult",
  },
  {
    title: "Hormone Replacement Therapy",
    image: IMAGES.provider,
    alt: "Hormone therapy consultation",
    items: ["Personalized HRT for women", "Personalized HRT for men", "Ongoing wellness support"],
    service: "hrt-women",
  },
  {
    title: "Microneedling & PRP",
    image: IMAGES.hero,
    alt: "Microneedling treatment space",
    items: ["Collagen-induction therapy", "Platelet-rich plasma facials", "Skin texture & tone renewal"],
    service: "microneedling-prp",
  },
  {
    title: "Facial Tox & Migraine Tox",
    image: IMAGES.leaf,
    alt: "Botanical texture",
    items: ["Full-face neurotoxin balancing", "Therapeutic tox for chronic migraine", "Conservative, natural dosing"],
    service: "facial-tox",
  },
  {
    title: "Utah Medical Cannabis Cards",
    image: IMAGES.cannabis,
    alt: "Green medical cross",
    items: ["New patient evaluations — $125 in person", "Renewals — $75 by telehealth", "Certified by a Qualified Medical Provider"],
    service: "cannabis-new",
  },
];

export default function ServiceBento() {
  return (
    <section id="services" data-testid="services-section" className="border-t border-linen bg-ivory py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-6 sm:px-8">
        <Reveal>
          <Kicker>Services</Kicker>
          <div className="mt-4 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <h2 className="max-w-xl font-serif text-4xl font-medium leading-tight tracking-tight text-forest sm:text-5xl">
              The art of looking like you
            </h2>
            <p className="max-w-md text-sm leading-relaxed text-moss sm:text-base">
              Every treatment begins with a complimentary 30-minute
              consultation. Honest recommendations, never pressure.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {CARDS.map((card, i) => (
            <Reveal key={card.title} delay={i * 0.05}>
              <article data-testid={`service-card-${card.service}`} className="group">
                <Link to={`/services/${card.service}`} className="block overflow-hidden rounded-lg">
                  <img
                    src={card.image}
                    alt={card.alt}
                    className="aspect-[4/3] w-full object-cover transition-transform duration-500 group-hover:scale-[1.02]"
                  />
                </Link>
                <h3 className="mt-6 font-serif text-2xl font-medium text-forest">{card.title}</h3>
                <ul className="mt-3 space-y-1 text-sm text-moss">
                  {card.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
                <div className="mt-5 flex items-center gap-6 text-sm font-semibold">
                  <Link
                    to={`/services/${card.service}`}
                    data-testid={`service-learn-${card.service}`}
                    className="text-moss underline-offset-4 transition-colors duration-300 hover:text-forest hover:underline"
                  >
                    Learn more
                  </Link>
                  <Link
                    to={`/book?service=${card.service}`}
                    data-testid={`service-book-${card.service}`}
                    className="flex items-center gap-2 text-forest transition-colors duration-300 hover:text-gold-dark"
                  >
                    Book this service <ArrowRight size={15} />
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
